import React from 'react';
import gif from '../Assets/error.gif';

const Error = () => {
    return ( <img src={gif} style={{width:"100%", height:"auto"}} /> );
}
 
export default Error;<img src={gif} />